import Client from './client';

export default class ShopifyOrders extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getTraceByShopifyOrderId(organization, shopifyOrderId, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/order/trace/${shopifyOrderId}`, options);
  }

}
